/**
 * כרטיס קבוצת שדות בטופס הפאנל — DESIGN.md 8.4: "כרטיס לבן אחד לכל קבוצת
 * שדות, כותרת קבוצה Rubik 500".
 */
import type { ReactNode } from 'react';

interface FormCardProps {
  title: string;
  children: ReactNode;
}

export function FormCard({ title, children }: FormCardProps) {
  return (
    <div
      className="bg-canvas rounded-lg border border-line p-5"
      style={{ boxShadow: 'var(--shadow-card)' }}
    >
      <h2 className="font-medium">{title}</h2>
      <div className="mt-4 space-y-5">{children}</div>
    </div>
  );
}
